<template>
    <div class="sub-page">
        <div class="main_section">
            <div class="section_item honor-block">
                <h2 class="title">{{honorTitle}}</h2>
                <div class="center">
                    <div v-for="(honor, index) in honorListFilter" :key="index" class="honor-item">
                        <img :src="honor.file" alt="">
                        <strong>{{isCn?honor.cnName:honor.enName}}</strong>
                    </div>
                </div>
                <div class="more-row" v-show="!isMoreHonor">
                    <span class="btn-more" @click="moreHonor">{{lang.spread}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'corpHonor',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            honorTitle: '',
            honorList: [],
            honorListFilter: [],
            isMoreHonor: false,
        };
    },
    mounted() {
        ajax.get('/web/about_us/file_list.json', { type: 'companyHonor' }).then((result) => {
            this.honorList = result.data.aboutUsFileList;
            this.honorListFilter = result.data.aboutUsFileList.slice(0, 6);
            this.honorTitle = this.isCn ? result.data.cnTitle : result.data.enTitle;
            this.isMoreHonor = (result.data.aboutUsFileList.length <= 6);
        }).catch(() => {});
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        moreHonor() {
            this.isMoreHonor = true;
            this.honorListFilter = this.honorList;
        },
    },
};
</script>
<style lang="less" scoped>
    .main_section{
        border-top: 8px solid #F8FAF9;
        width: 100%;
        height: auto;
        .section_item{
            width: 100%;
            height: auto;
            &:nth-child(even){
                background:rgba(248,250,249,1);
            }
            .title{
                padding-top: 40px;
                font-size: 20px;
                font-weight: 600;
                color: rgba(74,74,74,1);
                line-height: 20px;
                text-align: center;
                position: relative;
                &::after{
                    content:"";
                    width:44px;
                    height:4px;
                    background:rgba(199,31,75,1);
                    position: absolute;
                    bottom: -12px;
                    left: 50%;
                    margin-left: -22px;
                }
            }
        }
    }
    .center {
        margin: 0 auto;
        width: 960px;
        padding: 24px 0 40px;
        display: flex;
        justify-content: space-between;
    }
    .honor-block .center {
        justify-content: flex-start;
        flex-wrap: wrap;
        .honor-item {
            padding: 16px 30px;
            background: #fff;
            margin-right: 15px;
            margin-bottom: 15px;
            width: 310px;
            min-height: 244px;
            img {
                width: 250px;
                height: 160px;
            }
            strong {
                display: block;
                margin-top: 12px;
                font-size: 14px;
                line-height: 20px;
                font-weight: 500;
                word-break: break-word;
                color: #4A4A4A;
                text-align: center;
            }
            &:nth-child(3n){
                margin-right: 0;
            }
        }
    }
    .more-row {
        padding-bottom: 46px;
        text-align:center;
        .btn-more {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #4A4A4A;
            border: 1px solid #C71F4B;
        }
    }
</style>
